<template>
  <div class="company-add">
    <div class="company-add-head">
      <bcc-breadcrumb>
        <bcc-breadcrumb-item :to="{name: 'home'}">首页</bcc-breadcrumb-item>
        <bcc-breadcrumb-item>认证申请</bcc-breadcrumb-item>
      </bcc-breadcrumb>
      <h3>填写说明</h3>
    </div>

    <div class="company-add-steps">
      <div class="company-add-step-item">
        <div class="company-add-step-icon">
          <span>1</span>
          <img src="../../assets/line.png" alt="">
        </div>
        <p class="main-text">申请资料</p>
        <p class="sub-text">请填写入驻申请资料，包括企业名称、地址及简介等信息，申请哔哩哔哩企业开发者资质</p>
      </div>

      <div class="company-add-step-item">
        <div class="company-add-step-icon">
          <span>2</span>
          <img src="../../assets/line.png" alt="">
        </div>
        <p class="main-text">联系方式</p>
        <p class="sub-text">请填写联系人及联系邮箱、手机等方式，方便我们及时联络你并提供相应服务</p>
      </div>

      <div class="company-add-step-item">
        <div class="company-add-step-icon">
          <span>3</span>
          <img src="../../assets/line.png" alt="">
        </div>
        <p class="main-text">认证资质</p>
        <p class="sub-text">请提交《营业执照》以及《企业认证申请公函》等认证材料，作为平台审核凭证！</p>
      </div>

      <div class="company-add-step-item">
        <div class="company-add-step-icon complete">
          <i class="bcc-iconfont bcc-icon-ic_MenuButton-tick"></i>
        </div>
        <p class="main-text complete">审核通过</p>
        <p class="sub-text">平台收到申请后会及时反馈并为您确认，审核通过后您即可创建应用啦～</p>
      </div>
    </div>

    <div class="company-add-btn">
      <bcc-button size="max-large" type="primary" style="margin-right: 8px" @click="nextAdd">填写申请</bcc-button>
      <bcc-button size="max-large" style="margin-left: 8px" @click="cancelAdd">下次继续</bcc-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "companyAdd",
  methods: {
    nextAdd() {
      this.$emit('next')
    },
    cancelAdd() {
      this.$router.push({name: 'home'})
      // this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.company-add {
  max-width: 1168px;
  min-width: 960px;
  box-sizing: border-box;
  margin: 0 auto;

  .company-add-head {
    padding: 6px 26px;
    margin-top: 32px;

    h3 {
      margin-top: 16px;
      font-size: 24px;
    }
  }

  .company-add-steps {
    margin-top: 32px;
    padding: 45px 0 32px;
    background: #FFFFFF;
    border: 1px solid #E7E7E7;

    .company-add-step-item {
      display: flex;
      align-items: center;
      padding: 16px 61px 48px;
      margin-left: 120px;

      .company-add-step-icon {
        height: 24px;
        width: 24px;
        border-radius: 50%;
        border: 1px solid #02A1D6;
        background: rgba(0, 161, 214, 0.80);
        box-sizing: border-box;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 23px;
        position: relative;

        &.complete {
          background-color: #ffffff;
          border: 1px solid #02A1D6;
          color: rgba(0, 161, 214, 0.80);
          line-height: 23px;
        }

        img {
          display: block;
          height: 54px;
          width: 1px;
          position: absolute;
          top: 80%;
          left: 50%
        }
      }

      .main-text {
        font-size: 20px;
        color: #212121;
        margin-left: 24px;
        font-weight: 700;

        &.complete {
          font-weight: inherit;
        }
      }

      .sub-text {
        margin-left: 50px;
        font-size: 14px;
        color: #505050;
      }
    }
  }

  .company-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px 0;
    height: 80px;
  }
}
</style>
